import Alpine from 'alpinejs';

window.Alpine = Alpine;

document.addEventListener('alpine:init', () => {

    Alpine.store('alerts', {
        messages: [],

        addMessage(type, title, message = null) {
            message = message.replace("\n", '<br />');
            const m = {
                title: title,
                message: message,
                type: type,
                show: true
            }
            this.messages.push(m);
        },

        error(message) {
            this.addMessage('danger', 'Error occurred', message);
        },

        danger(message) {
            this.addMessage('danger', 'Danger', message);
        },

        warning(message) {
            this.addMessage('warning', 'Warning',message);
        },

        success(message) {
            this.addMessage('success', 'Success', message);
        },
    });


})
